import React from 'react';
import { DateInput, DateInputProps, Flex, Text } from 'pounceV2';
import { CompoundInputChildElementProps } from '../CompoundInputV3';

export type CompoundDateInputProps = Omit<CompoundInputChildElementProps, 'value' | 'onChange'> &
  Omit<DateInputProps, 'value' | 'onChange' | 'withIcon' | 'renderInput' | 'label'> & {
    value?: string | null;
    onChange: (date: string | null) => void;
  };

const CompoundDateInputV3 = React.forwardRef<HTMLInputElement, CompoundDateInputProps>(
  function CompoundDateInput(
    { value, timezone = 'local', onKeyDown, format, ...rest }: CompoundDateInputProps,
    ref,
  ) {
    const timezoneLabels: Record<string, string> = { utc: 'UTC', local: 'Local' };
    const timezoneLabel = timezoneLabels[timezone];

    return (
      <Flex align="center" gap={1}>
        <DateInput
          {...rest}
          label=""
          format={format}
          timezone={timezone}
          value={value ? new Date(value) : undefined}
          onChange={date =>
            rest.onChange(date != null && !Number.isNaN(date.getTime()) ? date.toISOString() : null)
          }
          slotProps={{
            textField: {
              hiddenLabel: true,
              inputRef: ref,
              inputProps: { onKeyDown },
              sx: {
                width: 'auto',
                minWidth: 'auto',
                '& fieldset': { border: 'none' },
                '& .Mui-focused fieldset': { border: 'none !important' },
                '& .MuiPickersSectionList-root': { padding: '7px 0px 7px' },
                '& .MuiInputBase-root': {
                  backgroundColor: 'transparent',
                  fontSize: 'inherit',
                  color: 'inherit',
                },
                '& .MuiInputBase-input': {
                  padding: '0 4px 0 0',
                  color: 'inherit',
                  fontSize: 'inherit',
                },
              },
            },
          }}
        />
        {timezoneLabel && (
          <Text fontSize="inherit" color="inherit">
            ({timezoneLabel})
          </Text>
        )}
      </Flex>
    );
  },
);

export default CompoundDateInputV3;
